<template>
	<WurldDynamicTag
		v-bind="getAttrs($attrs)"
		:tag="legend ? 'fieldset' : 'div'"
		class="WurldCheckbox"
	>
		<legend
			v-bind="getAttrs($attrs, 'legend')"
			v-if="legend"
		>{{ legend }}</legend>
		<div
			v-bind="getAttrs($attrs, 'group')"
			v-for="(option, key) in options"
			:key="`${guid}${key}`"
			class="WurldCheckbox__group"
		>
			<label
				v-bind="getAttrs($attrs, 'label')"
				v-html="option.label"
				v-if="labelBefore"
				:for="`${guid}${key}`"
			></label>
			<input
				@input="onOptionChange($event.target.value)"
				v-bind="getAttrs($attrs, 'checkbox')"
				:id="`${guid}${key}`"
				:name="name ? options.length < 2 ? name : `${name}[]` : null"
				type="checkbox"
				:value="option.value"
				:checked="values ? values.includes(option.value) : false"
			>
			<label
				v-bind="getAttrs($attrs, 'label')"
				v-html="option.label"
				v-if="!labelBefore"
				:for="`${guid}${key}`"
			></label>
		</div>
	</WurldDynamicTag>
</template>

<script>
import WurldDynamicTag from '@/components/Helpers/WurldDynamicTag';
export default {
	name: 'WurldCheckbox',
	inheritAttrs: false,
	components: {
		WurldDynamicTag
	},
	props: {
		labelBefore: {
			default: false,
			type: Boolean
		},
		legend: {
			default: null,
			type: String
		},
		name: {
			default: null,
			type: String
		},
		options: {
			required: true,
			type: Array
		},
		uid: {
			default: null,
			type: String
		},
		value: {
			default: null,
			type: Array
		}
	},
	data () {
		return {
			guid: '',
			values: this.value ? this.clone(this.value) : []
		};
	},
	mounted () {
		this.guid = this.uid ? this.uid : this.generateUID('WurldCheckbox');
	},
	methods: {
		onOptionChange (newVal) {
			if (this.values.includes(newVal)) {
				this.values = this.values.filter(val => val !== newVal);
			} else {
				this.values.push(newVal);
			}
			if (this.values.length > 0) {
				this.$emit('input', this.values);
			} else {
				this.$emit('input', null);
			}
		}
	}
};
</script>
